// Auto-advances multicolumn mobile sliders (e.g. trust badges) every 5s.
// Uses the slider's own built-in "next" button (native, safe) rather than
// any custom scroll/transform trick — previous attempts at a fancier,
// perfectly seamless loop caused real rendering breakage, so this trades a
// little polish for reliability.
// - Only runs on mobile-width viewports where the slider is actually shown
// - Pauses permanently as soon as the visitor swipes/taps/clicks it themselves
// - Respects the OS-level "reduce motion" accessibility setting
document.addEventListener('DOMContentLoaded', function () {
  var ADVANCE_MS = 5000;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var isMobileViewport = function () {
    return window.matchMedia('(max-width: 749px)').matches;
  };

  document.querySelectorAll('.multicolumn ul.slider--mobile').forEach(function (list) {
    var section = list.closest('.multicolumn');
    if (!section) return;
    var nextButton = section.querySelector('.slider-button--next');
    if (!nextButton) return;

    var timer = null;
    var stopped = false;

    var stop = function () {
      stopped = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    var tick = function () {
      if (stopped || !isMobileViewport()) return;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      if (atEnd) {
        list.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        nextButton.click();
      }
    };

    var start = function () {
      if (timer || stopped || !isMobileViewport()) return;
      timer = setInterval(tick, ADVANCE_MS);
    };

    ['touchstart', 'mousedown', 'wheel'].forEach(function (evt) {
      list.addEventListener(evt, stop, { passive: true });
    });

    start();
    window.addEventListener('resize', function () {
      if (isMobileViewport()) {
        start();
      } else {
        stop();
      }
    });
  });
});
